import { useAuth0 } from "@auth0/auth0-react";

// Management-side API for listing and updating staff
export function useStaffManagementAPI() {
  const { getAccessTokenSilently } = useAuth0();

  const fetchWithAuth = async (url, options = {}) => {
    const accessToken = await getAccessTokenSilently();
    const headers = new Headers(options.headers || {});
    headers.append("Authorization", `Bearer ${accessToken}`);
    if (!headers.has("Content-Type") && options.method && options.method !== "GET") {
      headers.append("Content-Type", "application/json");
    }
    return fetch(url, { ...options, headers });
  };

  // Fetch all staff entries (active and inactive)
  const listStaff = async () => {
    const url = `${process.env.REACT_APP_BACK_API}/staff`;
    const res = await fetchWithAuth(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  };

  // Toggle active state for a staff member
  const setStaffActive = async (uuid, active) => {
    const url = `${process.env.REACT_APP_BACK_API}/staff/${encodeURIComponent(uuid)}/active?active=${encodeURIComponent(
      active
    )}`;
    const res = await fetchWithAuth(url, { method: "PUT" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
  };

  const upsertStaff = async (payload) => {
    const hasUuid = !!payload?.uuid;
    const url = hasUuid
      ? `${process.env.REACT_APP_BACK_API}/staff/${encodeURIComponent(payload.uuid)}`
      : `${process.env.REACT_APP_BACK_API}/staff`;
    const method = hasUuid ? 'PUT' : 'POST';
    const body = { ...payload };
    // do not send undefined uuid on create
    if (!hasUuid) delete body.uuid;
    const res = await fetchWithAuth(url, { method, body: JSON.stringify(body) });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json?.() ?? null;
  };

  return { listStaff, setStaffActive, upsertStaff };
}
